<glxy-sticky-footer>
  <button mat-flat-button color="primary" (click)="submitClick.emit()" [disabled]="disabled">
    {{ submitOverride || 'AI_ASSISTANT.SHARED.SAVE' | translate }}
  </button>
  @if (!hideCancel && cancelLink) {
    <a mat-stroked-button [routerLink]="[cancelLink]">
      {{ cancelOverride || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </a>
  } @else if (!hideCancel) {
    <button mat-stroked-button (click)="cancelClick.emit()">
      {{ cancelOverride || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </button>
  }
</glxy-sticky-footer>
